import type { ComponentProps } from "react"
import cn from "@/v2-ui/utils/utils.cn"
import type { PublicHistoryDay } from "@/v2-status-client/status/status.types"
import StatusHistoryCell from "@/v2-status-client/status/history/StatusHistoryCell"
import { todayUtcKey } from "@/v2-status-client/status/history/status.history.utils"

export type StatusHistoryBarProps = ComponentProps<"div"> & {
  history: PublicHistoryDay[]
}

// 30-day status strip rendered next to every category and provider.
// One cell per day, customer-facing tooltips, no per-probe counts.
// Cells stretch the full width of the column with a flex rule
// (`.status-history-bar-cell` in status.css) so 30 cells still
// reads as 30 cells on a phone screen.
function StatusHistoryBar(props: Readonly<StatusHistoryBarProps>) {
  const { history, className, ...divProps } = props
  const todayKey = todayUtcKey()
  return (
    <div
      className={cn("flex items-stretch gap-[3px]", className)}
      role="img"
      aria-label="30-day uptime history"
      {...divProps}
    >
      {history.map((d) => (
        <StatusHistoryCell key={d.date} day={d} isToday={d.date === todayKey} />
      ))}
    </div>
  )
}

export default StatusHistoryBar
